<script>
    export default {
        props: {
            src: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                active: false,
            }
        },
        methods: {
            set_path(val) {
                if (!val) return;
                if (this.src === '/') {
                    this.active = val === this.src;
                } else {
                    this.active = val.indexOf(this.src) === 0;
                }
                this.$emit('active', this.active);
            },
            click() {
                this.$emit('click', this.src);
            },
        },
        mounted() {
            this.set_path(this.$route.fullPath);
            this.$watch('$route.fullPath', this.set_path)
        },
        computed: {
            href() {
                return '#' + this.src;
            },
            cls() {
                return {
                    'mag-link--disabled': this.disabled,
                    'mag-link--active': this.active,
                }
            },
        },
    }
</script>
<template>
    <a :href="href" class="mag-link" :class="cls" @click="click">
        <slot></slot>
    </a>
</template>
<style lang="scss">
    .mag-link {
        text-decoration: none;
        &--disabled {
            pointer-events: none;
            cursor: no-drop;
        }
    }
</style>
